import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, patchData, postData } from "src/utils/axios/serverHelper";
import { HRM3050_R01DetailDto, HRM3050_R01Dto, HRM3050_R01HeaderDto } from "./Dto_HRM3050_R01";
import { HRM3050_R01Filter } from "./Store_HRM3050_R01";

// 모든 HRM3050_R01 요청의 공통 API 경로이다.
const baseUrl = `${config.apiUrl}/HRM3050_R01`;

/**
 * 검색 또는 저장 후 재조회 조건으로 근무조 목록을 가져온다.
 * @param option search 또는 refetch 경로
 * @param params 사용여부 조건
 * @param listLength 요청에 포함하지만 현재 백엔드 목록 쿼리에서는 사용하지 않는 목록 길이
 * @returns 근무조 배열을 담은 서버 응답
 */
export const getHRM3050_R01List = async (option: string, params: Partial<HRM3050_R01Filter>, listLength: number = 0) =>
    await getData<ResponseDto<HRM3050_R01HeaderDto[]>>(`${baseUrl}/header/${option}`, { params: { ...params, listLength } });

/** 같은 검색 조건에 해당하는 근무조 전체 건수를 담은 서버 응답을 반환한다. */
export const getHRM3050_R01AllCount = async (params: Partial<HRM3050_R01Filter>) =>
    await getData<ResponseDto<number>>(`${baseUrl}/header/allCount`, { params: { ...params } });

/** 근무조코드를 URL 인코딩해 그 근무조의 휴게 목록 응답을 반환한다. */
export const getHRM3050_R01DetailList = async (shiftCd: string) =>
    await getData<ResponseDto<HRM3050_R01DetailDto[]>>(`${baseUrl}/detail/${encodeURIComponent(shiftCd)}`);

/** 신규 근무조 1건과 휴게 목록을 등록하고 저장된 근무조·휴게 응답을 반환한다. */
export const postHRM3050_R01 = async (data: HRM3050_R01Dto) =>
    await postData<HRM3050_R01Dto, ResponseDto<HRM3050_R01Dto>>(baseUrl, data);

/** 기존 근무조 1건을 수정하고 휴게 목록을 요청 목록과 같게 맞춘 뒤 저장된 근무조·휴게 응답을 반환한다. */
export const patchHRM3050_R01 = async (data: HRM3050_R01Dto) =>
    await patchData<HRM3050_R01Dto, ResponseDto<HRM3050_R01Dto>>(baseUrl, data);

/** 선택 근무조의 휴게 목록 Excel 데이터를 요청하고 인코딩된 파일 응답을 반환한다. */
export const downloadExcel_HRM3050_R01 = async (shiftCd: string) =>
    await getData<ResponseDto<string>>(`${baseUrl}/detail/${encodeURIComponent(shiftCd)}/excel`);

/** 일일근태 재계산을 요청하고 재계산 건수(대상이 없으면 0) 응답을 반환한다. */
export const postHRM3050_R01AttendDailyRecalculation = async () =>
    await postData<undefined, ResponseDto<number>>(`${baseUrl}/attendDaily/recalculate`, undefined);
